export const TRAINING_VIDEO_WEEK_FIELDS = [
  { key: "first_week", label: "1st Week" },
  { key: "second_week", label: "2nd Week" },
  { key: "third_week", label: "3rd Week" },
  { key: "fourth_week", label: "4th Week" },
  { key: "fifth_week", label: "5th Week" },
] as const;

export const TRAINING_VIDEO_DAY_FIELDS = [
  { key: "sunday", label: "Sun" },
  { key: "monday", label: "Mon" },
  { key: "tuesday", label: "Tue" },
  { key: "wednesday", label: "Wed" },
  { key: "thursday", label: "Thu" },
  { key: "saturday", label: "Sat" },
] as const;

export type TrainingVideoWeekKey =
  (typeof TRAINING_VIDEO_WEEK_FIELDS)[number]["key"];
export type TrainingVideoDayKey =
  (typeof TRAINING_VIDEO_DAY_FIELDS)[number]["key"];

export type TrainingVideoScheduleFlags = Record<
  TrainingVideoWeekKey | TrainingVideoDayKey,
  boolean
>;

const parseApiBoolean = (value: unknown) =>
  value === true || value === "true";

export const createEmptyScheduleFlags = (): TrainingVideoScheduleFlags => {
  const flags = {} as TrainingVideoScheduleFlags;
  TRAINING_VIDEO_WEEK_FIELDS.forEach(({ key }) => {
    flags[key] = false;
  });
  TRAINING_VIDEO_DAY_FIELDS.forEach(({ key }) => {
    flags[key] = false;
  });
  return flags;
};

export const scheduleFlagsFromApi = (
  data: Record<string, unknown> | null | undefined
): TrainingVideoScheduleFlags => {
  const flags = createEmptyScheduleFlags();
  if (!data) return flags;

  TRAINING_VIDEO_WEEK_FIELDS.forEach(({ key }) => {
    flags[key] = parseApiBoolean(data[key]);
  });
  TRAINING_VIDEO_DAY_FIELDS.forEach(({ key }) => {
    flags[key] = parseApiBoolean(data[key]);
  });

  return flags;
};

export const appendScheduleFlagsToForm = (
  form: FormData,
  flags: TrainingVideoScheduleFlags
) => {
  TRAINING_VIDEO_WEEK_FIELDS.forEach(({ key }) => {
    form.append(key, String(flags[key]));
  });
  TRAINING_VIDEO_DAY_FIELDS.forEach(({ key }) => {
    form.append(key, String(flags[key]));
  });
  form.append("friday", "false");
};

export const formatSchedulePreview = (
  flags: TrainingVideoScheduleFlags
): string[] => {
  const selectedWeeks = TRAINING_VIDEO_WEEK_FIELDS.filter(({ key }) => flags[key]);
  const selectedDays = TRAINING_VIDEO_DAY_FIELDS.filter(({ key }) => flags[key]);

  if (selectedWeeks.length === 0 || selectedDays.length === 0) return [];

  return selectedWeeks.map(
    ({ label }) =>
      `${label}: ${selectedDays.map(({ label: dayLabel }) => dayLabel).join(", ")}`
  );
};
